/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ArchiveUserInput = {
    userId: string;
    clientMutationId?: string | null | undefined;
};
export type UserListRowArchiveUserMutationVariables = {
    input: ArchiveUserInput;
};
export type UserListRowArchiveUserMutationResponse = {
    readonly archiveUser: {
        readonly clientMutationId: string | null;
        readonly user: {
            readonly __typename: string;
            readonly archived: boolean | null;
            readonly id: string;
        };
    } | null;
};
export type UserListRowArchiveUserMutation = {
    readonly response: UserListRowArchiveUserMutationResponse;
    readonly variables: UserListRowArchiveUserMutationVariables;
};



/*
mutation UserListRowArchiveUserMutation(
  $input: ArchiveUserInput!
) {
  archiveUser(input: $input) {
    clientMutationId
    user {
      __typename
      archived
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ArchiveUserPayload",
    "kind": "LinkedField",
    "name": "archiveUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "archived",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserListRowArchiveUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserListRowArchiveUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "15c1b95b8a0a0096865227dffefed716",
    "id": null,
    "metadata": {},
    "name": "UserListRowArchiveUserMutation",
    "operationKind": "mutation",
    "text": "mutation UserListRowArchiveUserMutation(\n  $input: ArchiveUserInput!\n) {\n  archiveUser(input: $input) {\n    clientMutationId\n    user {\n      __typename\n      archived\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '60f61d108d215230e660bff5bd18510f';
export default node;
